export const FETCH_AUTHORITIES_PENDING = 'FETCH_AUTHORITIES_PENDING';
export const FETCH_AUTHORITIES_SUCCESS = 'FETCH_AUTHORITIES_SUCCESS';
export const FETCH_AUTHORITIES_FAILURE = 'FETCH_AUTHORITIES_FAILURE';
export const RESET_AUTHORITIES = 'RESET_AUTHORITIES';
